module.exports = __webpack_public_path__ + "img/01_mov.fd2c4eab.webp";